/**
 * Sub1 Template
 * @category testApp
 */
class ItemInfoTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {String} _serverType=''
     */
    static getTempl(_d={}, _serverType='', _itemType='') {
        let defaultItem1_LIVE = [[1,'무기'], [6,'반지'], [3,'귀걸이'], [7,'목걸이'],[16,'팔찌'],[17,'허리띠'],[32,'장갑'],[36,'비공패'],[35,'신공패'],[64,'외공천'],[65,'내공천'],[22,'령'],[31,'혼'],[33,'수호석'],[37,'성']];
        let defaultItem2_LIVE = [[59,'환영무기'],[60,'수호석 원석'],[2,'의상'],[18,'의상장식'],[5,'머리장식'],[4,'얼굴장식'],[54,'환영연출'], [55, '환영 대기 연출'], [38, '탈것'], [61, '명패'], [62, '말풍선']]; //[, '초상화 테두리'], [, '소통 기호'],
        let defaultItem1_NEO = [[1,'무기'], [3,'귀걸이'], [7,'목걸이'],[35,'신공패'],[16,'팔찌'],[36,'비공패'],[17,'허리띠'],[6,'반지'],[32,'장갑']];
        let defaultItem2_NEO= [[59,'환영무기'],[55,'아이들 환영연출'],[2,'의상'],[57,'초상화 프레임'],[18,'의상장식'],[62,'말풍선'],[5,'머리장식'],[61,'명패'],[4,'얼굴장식'],[56,'채팅 심볼'],[54,'환영연출']];
        let liveDefaultData, liveDefaultData2;

        if(_serverType === 'LIVE'){
            liveDefaultData = new Map(defaultItem1_LIVE);
            liveDefaultData2 = new Map(defaultItem2_LIVE);
        }
        else{ // NEO
            liveDefaultData = new Map(defaultItem1_NEO);
            liveDefaultData2 = new Map(defaultItem2_NEO);
        }

        let defaultData = (_itemType == '1') ? liveDefaultData:liveDefaultData2;
        //장비
        let posArray = Array.from(defaultData.keys());
        let nameArray = Array.from(defaultData.values());
        let ItemList = $('<ul class="character-info-list"></ul>');
        for(let i=0; i<posArray.length; i++){
            ItemList.append(ItemInfoTempl.getItemBasicListTempl(_serverType,nameArray,posArray[i], i));
        }

        for(let i=0; i<_d.length; i++){
            let posIndex = posArray.indexOf(_d[i].pos);

            if(posIndex !== -1 && _d[i].item){
                ItemList[0].children[posIndex].querySelectorAll('.info-thumb>img')[0].src = _d[i].item.icon;
                ItemList[0].children[posIndex].querySelectorAll('.info-text')[0].innerHTML = _d[i].item.name;
                ItemList[0].children[posIndex].querySelectorAll('.info-text-wrap')[0].className += ' item-color-'+ _d[i].item.grade;
            }
        }
        return ItemList[0];
    }

    static getItemBasicListTempl(_serverType,_defaultNameArray,_index, _txtIndex){
        return `
            <li>
                <span class="info-thumb bg-item-${_index}"><img alt=""></span>
                <div class="info-text-wrap"><span class="info-text">${_defaultNameArray[_txtIndex]}</span></div>
            </li>
        `;
    }
} // end of class

export default ItemInfoTempl;
